import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from "ngx-spinner";
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import { UserService } from '../user.service';
import { Observable } from 'rxjs/Rx';
import { map } from 'rxjs/operators';
import * as firebase from 'firebase/app';
import { i18nMetaToJSDoc } from '@angular/compiler/src/render3/view/i18n/meta';
import { SearchShoe } from '../search-shoe';

@Injectable({
  providedIn: 'root',
})
export class FavoritesListService {

  public favorites = []; 

  constructor(private http: HttpClient, private SpinnerService: NgxSpinnerService, private afs: AngularFirestore, private userService: UserService, private auth: AngularFireAuth) { }

  getFavorites()
  {
    return this.favorites;
  }

  async addToFavorites(shoe)
  {
    let tempUser = this.userService.currentUser;

    tempUser = 
    {
      displayName: tempUser.displayName,
      email: tempUser.email,
      photoURL: tempUser.photoURL,
      uid: tempUser.uid
    };

    this.afs.collection('favorites').add(
      {
        user: tempUser,
        id: shoe.id,
        brand: shoe.brand,
        gender: shoe.gender,
        img: shoe.img,
        retailPrice: shoe.retailPrice,
        shoe: shoe.shoe,
        name: shoe.name
      }
    )

    await this.getFavoritesFromFirestore();
    //this.favorites.push(shoe);
  }

  async removeFromFavorites(shoe)
  {
    //console.log(shoe);

    //this.favorites.splice(this.favorites.indexOf(shoe), 1);
    let deleteFavoritesQuery = await this.afs.collection('favorites', ref => ref.where('user.uid', '==', this.userService.currentUser.uid).where('id', '==', shoe.id));
    deleteFavoritesQuery.get().toPromise().then(function(querySnapshot)
    {
      querySnapshot.forEach(function(doc)
      {
        doc.ref.delete();
      })
    })

    await this.getFavoritesFromFirestore();
  }

  async getFavoritesFromFirestore() {
    if(this.userService.currentUser == undefined || this.userService.currentUser == null)
    {
      console.log("No one is logged in");
      return [];
    }
    else
    {
      return new Promise<void>(async resolve => 
      {
        let favoritesQuery = await this.afs.collection('favorites', ref => ref.where('user.uid', '==', this.userService.currentUser.uid));
      
        favoritesQuery.valueChanges().subscribe(data =>
        {
          this.favorites = data;
          console.log(this.favorites);
          resolve();
        });
      });
    }
  }
    
  //   else
  //   {
  //     let favoritesQuery = await this.afs.collection('favorites', ref => ref.where('user.uid', '==', this.userService.currentUser.uid));
  //     this.favorites = await favoritesQuery.get().toPromise().then(function(querySnapshot)
  //     {
  //       let tempFavorites = [];

  //       querySnapshot.forEach(function(doc)
  //       {
  //         let tempShoe =
  //         {
  //           id: doc.get("id"),
  //           brand: doc.get("brand"),
  //           gender: doc.get("gender"),
  //           img: doc.get("img"),
  //           retailPrice: doc.get("retailPrice"),
  //           shoe: doc.get("shoe"),
  //           name: doc.get("name")
  //         }

  //         tempFavorites.push(tempShoe);
  //       });

  //       return tempFavorites;
  //     })
  //     console.log(this.favorites);
  //     console.log("Someone is logged in");
  //   }
  // }
}